import CustomApiError from "./CustomApiError"

export default class InsufficientBalanceError extends CustomApiError {
  message = "Insufficient Honey Balance"
}
